import Link from "next/link";

type questionsProps = {
  data: any;
  title?: string;
  topicId: string;
};

const Questions = ({ data, title, topicId }: questionsProps) => {
  return (
    <div className="question-container">
      <h2 className="question-header">Pertanyaan yang sering diajukan</h2>
      {title && title != "" && (
        <h3 className="question-header-by-title">{title}</h3>
      )}
      <div className="question-list-wrapper">
        {data &&
          data.map((i, key) => (
            <div key={key}>
              <li className="question-list">
                <Link
                  href="/pertanyaan-umum/[topicId]/[topicItem]"
                  as={`/pertanyaan-umum/${topicId.replace(
                    /_/g,
                    "-"
                  )}/${i.key.replace(/_/g, "-")}`}
                  legacyBehavior>
                  <a>{i.question}</a>
                </Link>
              </li>
              <hr />
            </div>
          ))}
      </div>

      <style jsx>{`
        hr {
          border: 1px solid var(--color-white);
        }

        .question-header {
          font-weight: bold;
        }

        .question-header-by-title {
          display: none;
        }

        .question-list {
          color: var(--color-gray);
          list-style-type: none;
          font-size: 16px;
          line-height: 23px;
          margin: 0 0 16px 0;
        }

        @media only screen and (max-width: 600px) {
          hr {
            border: 1px solid var(--color-white-soft);
          }
          .question-header-by-title {
            margin: 24px 0;
            display: block;
          }
          .question-header {
            display: none;
          }
          .question-list {
            align-items: center;
            margin: 16px 0;
          }
        }
      `}</style>
    </div>
  );
};
export default Questions;
